import { useState } from "react";
import { Check, X, Undo2, ArrowLeft } from "lucide-react";
import { onField, shootoutScore } from "@/lib/events";
import { teamStyle } from "@/lib/colors";
import { CardButtons } from "@/components/CardButtons";

const Kicks = ({ match, side }) => {
  const kicks = (match.shootout || []).filter((k) => k.team === side);
  return (
    <div data-testid={`shootout-${side}-kicks`} className="flex flex-wrap gap-2 min-h-10">
      {kicks.map((k, i) => (
        <span key={k.id} data-testid={`shootout-${side}-kick-${i + 1}`} title={k.scored ? "Marcou" : "Falhou"}
          className={`h-10 px-2 min-w-10 flex items-center justify-center gap-1 font-display font-bold ${k.scored ? "bg-[#34C759] text-black" : "bg-[#FF3B30] text-white"}`}>
          {k.scored ? <Check size={14} /> : <X size={14} />}{k.player}
        </span>
      ))}
      {!kicks.length && <span className="text-sm text-zinc-600 self-center">Sem penáltis</span>}
    </div>
  );
};

const Kicker = ({ match, side, onKick }) => {
  const [player, setPlayer] = useState(null);
  const field = onField(match, side);
  const nums = match[side].players.map((p) => String(p.number));
  const sentOff = new Set(match.events.filter((e) => e.type === "vermelho" && e.team === side && e.target_type === "player").map((e) => e.target));
  const list = (field.size ? nums.filter((n) => field.has(n)) : nums).filter((n) => !sentOff.has(n));
  const kick = (scored) => { onKick({ team: side, player, scored }); setPlayer(null); };
  return (
    <div data-testid={`shootout-team-${side}`} className="flex-1 min-w-0 border border-white/15 bg-[#131313]">
      <div style={teamStyle(match[side])} className="flex items-center justify-between gap-3 px-4 py-3">
        <h3 className="font-display text-xl sm:text-2xl font-bold uppercase truncate">{match[side].name}</h3>
        <span data-testid={`shootout-${side}-score`} className="font-display text-3xl font-bold tabular-nums">{shootoutScore(match, side)}</span>
      </div>
      <div className="p-4 space-y-4">
        <Kicks match={match} side={side} />
        <p className="label-caps">Marcador do penálti</p>
        <div className="grid grid-cols-5 sm:grid-cols-6 gap-2">
          {list.map((n) => (
            <button key={n} data-testid={`shootout-${side}-player-${n}`} onClick={() => setPlayer(player === n ? null : n)} style={teamStyle(match[side])}
              className={`tap h-12 border font-display text-xl font-bold ${player === n ? "ring-4 ring-[#CCFF00] border-transparent z-10" : "border-white/30"}`}>
              {n}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-2">
          <button data-testid={`shootout-${side}-scored`} disabled={!player} onClick={() => kick(true)}
            className="tap h-14 bg-[#34C759] text-black font-display text-lg font-bold uppercase flex items-center justify-center gap-2 disabled:opacity-30">
            <Check size={20} /> Marcou
          </button>
          <button data-testid={`shootout-${side}-missed`} disabled={!player} onClick={() => kick(false)}
            className="tap h-14 bg-[#FF3B30] text-white font-display text-lg font-bold uppercase flex items-center justify-center gap-2 disabled:opacity-30">
            <X size={20} /> Falhou
          </button>
        </div>
      </div>
    </div>
  );
};

export const Shootout = ({ match, onChange, onBack, onCard }) => {
  const kicks = match.shootout || [];
  return (
    <section data-testid="shootout-panel" className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-display text-2xl sm:text-3xl font-bold uppercase">Desempate por penáltis</h2>
        <div className="flex gap-2">
          <button data-testid="shootout-undo" disabled={!kicks.length} onClick={() => onChange(kicks.slice(0, -1))}
            className="tap h-10 px-3 border border-[#FF3B30]/60 text-[#FF3B30] text-sm font-semibold flex items-center gap-2 hover:bg-[#FF3B30] hover:text-white disabled:opacity-30">
            <Undo2 size={16} /> Desfazer último
          </button>
          <button data-testid="shootout-back" onClick={onBack} className="tap h-10 px-3 border border-white/15 text-sm flex items-center gap-2 hover:bg-white/5">
            <ArrowLeft size={16} /> Voltar ao jogo
          </button>
        </div>
      </div>
      <p className="text-sm text-zinc-400">Escolha o jogador e registe se marcou ou falhou. Quando houver vencedor, carregue em Fim do jogo.</p>
      {onCard && (
        <div data-testid="shootout-cards">
          <p className="label-caps mb-2">Cartões durante os penáltis</p>
          <CardButtons testPrefix="shootout-card" onPick={onCard} />
        </div>
      )}
      <div className="flex flex-col md:flex-row gap-4">
        {["home", "away"].map((s) => (
          <Kicker key={s} match={match} side={s} onKick={(k) => onChange([...kicks, { ...k, id: crypto.randomUUID(), created_at: new Date().toISOString() }])} />
        ))}
      </div>
    </section>
  );
};
